const STORAGE_KEY = 'endpoint_testing_api_key';

export const getKey = () => localStorage.getItem(STORAGE_KEY);
export const setKey = (k) => localStorage.setItem(STORAGE_KEY, k);
export const clearKey = () => localStorage.removeItem(STORAGE_KEY);
export const isAuthenticated = () => Boolean(getKey());
